
export default {
  // 切换主题风格
  changeThemeStyle(state, data) {
    state.themeStyle.index = data;

    window.localStorage.setItem('themeStyle', JSON.stringify({ idx: state.themeStyle.index }))
  },

  // 切换主题颜色
  changeThemeColor(state, data) {
    state.themeColor.index = data;

    window.localStorage.setItem('themeColor', JSON.stringify({ idx: state.themeColor.index }))
  },

  // 切换访问历史状态(当前高亮)
  changeViewHistory(state, data) {
    state.viewHistory.index = data;
    window.localStorage.setItem('viewHistory', JSON.stringify(state.viewHistory));
  },

  // 更新历史访问记录数据
  updateViewHistory(state, data) {
    state.viewHistory.list = data.list;
	  state.viewHistory.index = data.idx;
  },

  // 添加历史访问记录
  addViewHistory(state, data) {
    let list = state.viewHistory.list;
    let len = list.length;

    for (let i = 0; i < len; i ++) {

      if (list[i].routerName === data.routerName) {
        return
      }
    }

    state.viewHistory.list.push(data);

    window.localStorage.setItem('viewHistory', JSON.stringify(state.viewHistory));
  },

  // 删除当前访问记录
  deleteViewHistory(state, data) {
    state.viewHistory.list.splice(data, 1);
    window.localStorage.setItem('viewHistory', JSON.stringify(state.viewHistory));
  },

	// 访问历史右键菜单控制
	changeHistoryRightMouseMenuStatus(state, data) {
		state.isShowHistoryRightMouseMenu.idx = data.idx;
		state.isShowHistoryRightMouseMenu.show = data.show;
	},

  // 切换菜单显示风格
  setMenuStyle(state, data) {
    state.menuStyle = data;
  },

  // 更新树形导航
  setMenuList(state, data) {
    state.menuList = data;
  },

  // 更新导航菜单状态(当前值)
  syncMenuStatus(state, data) {
    let sourceItem = '';
    for (let i = 0; i < state.menuList.length; i ++) {
      sourceItem = JSON.stringify(source[i]); // 把菜单项转为字符串
      if (sourceItem.indexOf(url) > -1) { // 查找当前 URL 所对应的子菜单属于哪一个祖先菜单
        if (source[i].type === 'button') { // 导航菜单为按钮
          source[i].isSelected = true; // 设置选中高亮
          // source[i].isExpanded = true; // 设置为展开
          this.startExpand.push(source[i]);
          // 递归下一级菜单，以此类推
          this.setExpand(source[i].subMenu, url);
        }
        break;
      }
    }
  },

  // 同步token数据
  syncToken(state, data) {
    state.token = data;
  },

  // 同步更新用户数据
  syncUserInfo(state, data) {
    console.log(data);
  },

  // 同步更新登录超时提示状态
  setLoginTimeOutCount(state, bol) {
    state.loginTimeout.isAlert = bol;
  },

  // 切换提示框类型(true：公共提示框，false：自定义提示框)
  exchangeAlarmType(state, data) {
    state.isPublicAlarm = data;
  },
  
  // 设置系统提示框显示位置
  setNotificationPos(state, data) {
    if (typeof data === 'string' && (data === 'bottom-right' || data === 'bottom-left' || data === 'top-left')) {
      state.notificationPos = data;
    }
  },
}
